import { render, staticRenderFns } from "./StudentsTable.vue?vue&type=template&id=d2a54e94&scoped=true&"
import script from "./StudentsTable.vue?vue&type=script&lang=js&"
export * from "./StudentsTable.vue?vue&type=script&lang=js&"
import style0 from "./StudentsTable.vue?vue&type=style&index=0&id=d2a54e94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a54e94",
  null
  
)

export default component.exports